// extracted by mini-css-extract-plugin
export default {"title":"ToxinContent_title__4w9qn","container":"ToxinContent_container__Ar-HF","product":"ToxinContent_product__BayiF","export":"ToxinContent_export__eOeas"};